export default {
  app: {
    privacy: {
      policy: 'Pribatutasun politika',
      expansive: 'Expansive erabiltzean, Expansive {action} onartzen duzu',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Saioa amaitu da',
    sessionExpiredDescription:
      'Zure saioa amaitu da. Mesedez, hasi saioa berriro aplikazioa erabiltzen jarraitzeko.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Hautatu hizkuntza',
      chooseLanguageDescription:
        'Hautatu aplikaziorako nahi duzun hizkuntza. Honek interfaze eta edukien hizkuntza aldatuko du.',
    },
    userSelection: {
      cancel: 'Utzi',
      createNewUser: 'Haien izena ez dago zerrendan',
      newUser: 'Erabiltzaile berria',
      selectAnExistingUser: 'Aukeratu dagoen erabiltzaile bat',
      selectUserHint: 'Aukeratu dagoen erabiltzaile bat edo sortu berri bat jarraitzeko.',
      startTypingToSearch: 'Hasi idazten...',
    },
    verification: {
      codeVerification: {
        continue: 'Jarraitu',
        header: 'Sartu guneko sarbide kodea',
        invalidCode: 'Kode baliogabea, saiatu berriro.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Jarraitu kokapena egiaztatu gabe',
        enterSiteAccessCode: 'Sartu guneko sarbide kodea',
        locationNotEnabledOrAvailable: 'Zergatik ikusten dut hau?',
        notAvailable: {
          description: 'GPS kokapena ez da gailu honetan onartzen.',
          header: 'Kokapena ez da onartzen',
        },
        notEnabled: {
          description: 'Kokapen zerbitzuak ez daude gaituta edo baimena ez da eman.',
          header: 'Kokapena ez dago gaituta',
        },
        notVerified: {
          description: 'GPSak adierazten du ez zaudela gunean.',
          header: 'Kokapena ez da egiaztatu',
        },
        tryAgain: 'Saiatu berriro',
        unavailable: {
          description: 'Ezin izan dugu zure GPS kokapena egiaztatu.',
          header: 'Kokapena ez dago erabilgarri',
        },
        unknown: {
          description: 'Ezin dugu zure kokapena zehaztu.',
          header: 'Kokapena ezezaguna',
        },
        verified: {
          description: 'GPSak adierazten du gunean zaudela.',
          header: 'Kokapena egiaztatuta',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Ez da aktiboen informaziorik aurkitu',
        emptyDescription: 'Ez da aktibo haundirik lan agindu honekin lotuta.',
        warrantyParts: 'Piezen berme epea amaitzen da',
        serialNumber: 'Serien zenbakia',
        none: '<ezer ere>',
      },
      updates: {
        emptyTitle: 'Ez da eguneratze informaziorik aurkitu',
        emptyDescription: 'Ez dago lan agindu honetarako eguneratzerik.',
        unknownUser: 'Erabiltzaile ezezaguna',
        none: 'Ezer ere',
        addComment: {
          buttonLabel: 'Iruzkin bat gehitu',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Arriskuak',
          no: 'Ez',
          yes: 'Bai',
        },
      },
    },
    attachmentsList: {
      attachments: 'Atxikipenak',
      documents: 'Dokumentuak',
      siteDocuments: 'Guneko Dokumentuak',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Arriskuak',
        induction: 'Sarrera',
        safeToProceed: 'Seguru jarraitzeko',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Epea',
        activeSessions: 'Saio aktiboak',
        activeSessionsDescription:
          'Jada hurrengo lan agindutan saioa hasi duzu. Lan agindu berri batean saioa hasi aurretik, irten behar duzu lan agindu hauetatik.',
        resumeSession: 'Jarraitu',
        startTime: 'Hasita',
        unexpectedErrorTitle: 'Errore ezustekoa',
        unexpectedErrorMessage:
          'Errore ezusteko bat gertatu da saioak sortzerakoan. Saiatu berriro geroago.',
        engineerNotFound: 'Ingeniaria ez da aurkitu',
        engineerNotFoundDescription:
          'Saioa hasi nahi duzun ingeniaria sisteman aurkitu ez dena. Mesedez, jarri harremanetan zure administratzailearekin.',
      },
      verification: {
        code: {
          description:
            'Saioa hasteko, mesedez, lortu 4-digituko kodea guneko arduradun edo kontaktu izendatuarengandik.',
        },
        geo: {
          continue: 'Jarraitu',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Mesedez, lortu sarbide-kodea gunearen kudeatzailearengandik edo izendatutako kontaktuarengandik zure bisita osatzeko.',
            checkOut: 'Irten',
            completeBeforeLeaving: 'Mesedez, bete ondorengo inprimakia irten aurretik.',
            continue: 'Jarraitu',
            noResolutionSelected: 'Mesedez, aukeratu ebazpen bat jarraitzeko.',
            quoteRequired: {
              hint: 'Bisita amaituta, aurrekontua bidaliko da',
              label: 'Aurrekontua beharrezkoa',
            },
            returnVisitRequired: {
              hint: 'Bisita amaituta, itzuliko gara osatzeko',
              label: 'Itzulera bisita beharrezkoa',
            },
            serviceCompleted: {
              hint: 'Ez da gehiago ekintza behar',
              label: 'Zerbitzua amaituta',
            },
            uploadCheckout: 'Kargatu fitxategi, argazki edo bideo bat',
            visitNotes: 'Bisita oharrak',
            workOrderResolution: 'Lan aginduko ebazpena',
            enterNotes: 'Idatzi hemen zure oharrak...',
            errors: {
              timedOut: 'Denbora agortu da, 30 segundo gainditu dira. Saiatu berriro mesedez.',
              closingSession: 'Errore bat gertatu da saioa itxitzerakoan',
            },
          },
          success: {
            description:
              'Eskerrik asko {site} bisatzeagatik. | {site} -k oraindik 1 lan agindu irekita du. | {site} -k {count} lan agindu irekita ditu oraindik.',
            endVisit: 'Bisita amaitu',
            header: 'Arrakastaz irten zara',
            viewWorkOrders: 'Sartu beste lan agindu batera',
          },
          verification: {
            code: {
              description:
                'Irten ahal izateko, mesedez, lortu 4-digituko kodea guneko arduradun edo kontaktu izendatuarengandik.',
              continue: 'Jarraitu',
            },
            geo: {
              checkOut: 'Irten',
              continue: 'Jarraitu',
            },
          },
        },
        detail: {
          assets: 'Aktiboak',
          call: 'Deitu',
          checkOut: 'Irten',
          closed: 'Itxita',
          details: 'Xehetasunak',
          dueBy: 'Epea',
          manageEngineers: 'Kudeatu ingeniariak',
          notAvailable: 'Ez dago eskuragarri',
          pointOfContact: 'Harremanetarako pertsona',
          siteAccessTimes: 'Gunera sartzeko orduak',
          siteAccessInstructions: 'Sarbide argibideak',
          siteAddress: 'Gunearen helbidea',
          siteNotes: 'Gunearen oharrak',
          siteTelephone: 'Gunearen telefonoa',
          siteLocation: 'Gunearen kokapena',
          updates: 'Eguneraketak',
          more: 'Gehiago',
          mismatchErrorTitle: 'Lan aginduko errorea',
          mismatchErrorMessage:
            'Sartu nahi duzun lan agindua ez dator zure egungo saioarekin bat etortzen. Mesedez, egiaztatu zure lan agindua eta saiatu berriro.',
          siteDocuments: 'Guneko dokumentuak',
          validFrom: 'Indarrean hasi',
          validUntil: 'Indarrean amaitu',
          documentName: 'Dokumentuaren izena',
          documentType: 'Dokumentu mota',
          attachments: 'Lan aginduko fitxategiak',
          download: 'Deskargatu',
          workDetails: 'Lan xehetasunak',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Gehitu laguntzaile ingeniaria',
            assistantEngineers: 'Laguntzaile ingeniariak',
            description:
              'Segurtasun arrazoiak direla eta, mesedez, adierazi gunean dauden ingeniarien izenak.',
            editMainEngineer: 'Editatu nagusi ingeniaria',
            errors: {
              creatingEngineer: 'Errore bat gertatu da ingeniaria sortzerakoan',
              creatingSession: 'Errore bat gertatu da saioa sortzerakoan',
            },
            header: 'Gunean dauden ingeniariak',
            mainEngineer: 'Nagusi ingeniaria',
            newAssistantEngineer: 'Idatzi haien izena eta abizenak',
            next: 'Hurrengoa',
            removeEngineer: 'Ezabatu ingeniaria',
            selectExistingAssistantEngineer: 'Hasi haien izena idazten',
          },
          index: {
            description:
              'Segurtasun arrazoiak direla eta, mesedez, adierazi gunean dauden ingeniarien izenak.',
            errorCreatingEngineer: 'Errore bat gertatu da ingeniaria sortzerakoan, saiatu berriro.',
            header: 'Gunean dauden ingeniariak',
            hintMainEngineer: 'Idatzi nagusi ingeniariaren izena eta abizenak',
            newMainEngineer: 'Nagusi ingeniaria',
            next: 'Hurrengoa',
            selectExistingMainEngineer: 'Aukeratu dagoen nagusi ingeniaria',
            yes: 'Bai',
            no: 'Ez',
            mainEngineerLabel: 'Zu al zara nagusi ingeniaria?',
          },
        },
        index: {
          callUsOn: 'Deitu iezaguzu {phoneNumber} zenbakira',
          description: 'Ez al duzu aurkitzen bilatzen duzuna?',
          dueBy: 'Epea',
          header: 'Aukeratu lan agindua',
          notAvailable: 'Ez dago eskuragarri',
          searchWorkOrders: 'Bilatu lan aginduak...',
        },
        manageEngineers: {
          manageEngineers: 'Kudeatu ingeniariak',
          notWorking: 'Inaktiboak',
          pause: 'Gelditu',
          resume: 'Jarraitu',
          workingNow: 'Aktiboak',
          startTime: 'Hasiera ordua',
          endTime: 'Amaiera ordua',
          duration: 'Iraupena',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Iruzkinak',
            feedbackDescription:
              'Mesedez, eman iritzia lan aginduari gure zerbitzuak hobetzen laguntzeko.',
            feedbackLabel: 'Iruzkinak',
            filesLabel: 'Atxikipenak',
            submissionLabel: 'Bidali iritzia',
          },
          hazards: {
            back: 'Itzuli',
            hazards: 'Arriskuak',
            next: 'Hurrengoa',
            no: 'Ez',
            noTasksForHazard: 'Ez dago arrisku honentzat bete beharreko zereginik.',
            yes: 'Bai',
          },
          induction: {
            continue: 'Jarraitu',
            induction: 'Sarrera',
          },
          index: {
            checkIn: 'Sartu',
            description: 'Mesedez, bete ondorengo arrisku ebaluazioa aukeratutako lanarentzat.',
            fail: 'Lan agindua hasi kontrolak prozesatzerakoan errorea.',
            haltMessage:
              'Arrisku posibleak detektatu dira. Mesedez, gelditu lan egitea, berrikusi segurtasun gidalerroak, eta jarri harremanetan zure arduradunarekin jarraitzeko argibide gehiago lortzeko.',
            header: 'Lan egiteko kontrolak',
            endVisit: 'Bisita amaitu',
            leaveFeedback: 'Utzi iritzia',
          },
          safeToProceed: {
            continue: 'Jarraitu',
            safeToProceed: 'Seguru jarraitzeko',
          },
        },
      },
    },
    index: {
      title: 'Ongi etorri',
      description: 'Zure kokalekuaren QR kodea eskaneatu hasi ahal izateko.',
    },
    login: {
      errorTitle: 'Errore ezustekoa',
      errorMessage: 'Errore ezusteko bat gertatu da. Mesedez, saiatu berriro QR kodea eskaneatzen.',
    },
    unauthenticated: {
      welcome: {
        title: 'Ongi etorri {site}ra',
        description:
          'Lan aginduak erakutsi ahal izateko, zure datuak egiaztatu behar ditugu. Mesedez, jarraitu beheko botoia klik eginez.',
        next: 'Jarraitu',
      },
      index: {
        errorTitle: 'Errore ezustekoa',
        errorMessage:
          'Errore ezusteko bat gertatu da. Mesedez, saiatu berriro QR kodea eskaneatzen.',
      },
      contractor: {
        title: 'Norentzat lan egiten duzu?',
        contractor: 'Kontratista',
        contractorLabel: 'Hasi zure enpresaren izena idazten',
        contractorHint: 'Sarrera 3 karaktere edo gehiago izan behar du emaitzak ikusteko',
        defaultSelectPlaceholder: '--Mesedez, aukeratu--',
        next: 'Hurrengoa',
      },
      user: {
        title: 'Nor zara zu?',
        cancel: 'Utzi',
        createNewUserLabel: 'Nire izena ez dago zerrendan',
        existingUserLabel: 'Hasi zure izena idazten',
        existingUserHint: 'Sarrera 3 karaktere edo gehiago izan behar du emaitzak ikusteko',
        newUserLabel: 'Idatzi zure izena eta abizenak',
        next: 'Hurrengoa',
        user: 'Erabiltzailea',
      },
      verification: {
        methods: {
          add: {
            add: 'Gehitu egiaztapen metodoa',
            defaultSelectPlaceholder: '--Mesedez, aukeratu--',
            emailLabel: 'Posta elektronikoa',
            existingMethodWarning:
              'Jalready have a pending request for this verification method awaiting admin approval. Adding a new one will override it.',
            method: 'Metodoa',
            methodLabel: 'Metodoa',
            mobileCountryHint: 'Mesedez, aukeratu zure herrialde kodea',
            mobileCountryLabel: 'Mugikorra herrialde kodea',
            mobileHint: 'Mesedez, idatzi zure mugikor zenbakia',
            mobileLabel: 'Mugikorra',
            title: 'Gehitu egiaztapen metodoa',
          },
          confirm: {
            confirm: 'Berretsi',
            description: 'Mesedez, berretsi zure egiaztapen metodoa jarraitzeko.',
            label: 'Idatzi zure kodea',
            resend: 'Berriro bidali',
            resendPrompt: 'Ez al duzu kodea jaso?',
            title: 'Egiaztapen Metodoa Berretsi',
          },
          confirmed: {
            description:
              "You'll be notified once this verification method has been approved by your admin, and you can then start using it to verify your identity.",
            forceApproval: "Until it's approved, you are unable to access work orders.",
            nonForceApproval:
              'In the meantime, you can continue to access work orders with reduced access.',
            nonForceApprovalButtonLabel: 'Continue with reduced access',
            title: 'Awaiting approval',
          },
          addNew: 'Gehitu egiaztapen metodo berri bat',
          description:
            'Zure identitatea egiaztatu behar dugu lan aginduari osoko sarbidea emateko.',
          email: 'Posta elektronikoa',
          hint: 'Gurekin harremanetan jartzeko, mesedez, erabili zure administratzailearen laguntza.',
          label: 'Aukeratu egiaztapen metodo bat',
          next: 'Hurrengoa',
          pendingHint: 'Administratzailearen onarpenaren zain',
          sms: 'SMS',
          title: 'Egiaztapena',
        },
        optional: {
          hint: 'Zure erabiltzaile datuak egiaztatzeak lan aginduari osoko sarbidea emango dizu',
          label: 'Zure erabiltzaile datuak egiaztatu nahi al dituzu?',
          next: 'Hurrengoa',
          no: 'Ez',
          noHint:
            'Ez dut nahi nire erabiltzaile datuak egiaztatzea eta lan aginduari sarbide murriztua izatea jarraitu',
          title: 'Egiaztapena',
          yes: 'Bai',
          yesHint:
            'Nire erabiltzaile datuak egiaztatzea eta lan aginduari osoko sarbidea izatea nahi dut',
        },
        sent: {
          description:
            'Saioa hasi lotura bat bidali zaizu {identifier}. Mesedez, klik egin lotura hori zure saioa amaitzeko.',
          title: 'Saioa hasi lotura bidali da',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Atzo',
      today: 'Gaur',
      days: {
        monday: 'Astelehena',
        tuesday: 'Asteartea',
        wednesday: 'Asteazkena',
        thursday: 'Osteguna',
        friday: 'Ostirala',
        saturday: 'Larunbata',
        sunday: 'Igandea',
      },
      months: {
        january: 'Urtarrila',
        february: 'Otsaila',
        march: 'Martxoa',
        april: 'Apirila',
        may: 'Maiatza',
        june: 'Ekaina',
        july: 'Uztaila',
        august: 'Abuztua',
        september: 'Iraila',
        october: 'Urria',
        november: 'Azaroa',
        december: 'Abendua',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Zerbait oker joan da',
      message: 'Mesedez, saiatu berriro QR kodea eskaneatzen.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Erabiltzaile ezezaguna',
      },
      none: 'Ezer ere',
      types: {
        stateTransition: 'Egoera aldaketa',
        contractorAssigned: 'Kontratista esleipena',
        engineerAssigned: 'Ingeniari esleipena',
        serviceAssigned: 'Zerbitzu esleipena',
        priorityChanged: 'Prioritate aldaketa',
        actionableDateChanged: 'Ekintza data aldaketa',
        dueDateChanged: 'Epea aldaketa',
        etaDateChanged: 'Iraupena aldaketa',
        spendLimitApproved: 'Iraupena onartuta',
        spendLimitCancelled: 'Iraupena bertan behera',
        spendLimitRejected: 'Iraupena ukatua',
        spendLimitRequested: 'Iraupena eskatu',
        jobSheetUploaded: 'Lan orria kargatuta',
        slaAlertSent: 'Denbora iristen ez den SLA alerta',
        issuedWorkPermit: 'Lan baimena emanda',
        requestForServiceSent: 'Zerbitzu eskaera bidalita',
        comment: 'Iruzkin bat gehitu',
        unknown: 'Gertaera ezezaguna',
      },
      labels: {
        actionableDate: 'Ekintza data',
        comment: 'Iruzkin',
        file: 'Fitxategia',
        contractor: 'Kontratista',
        dueDate: 'Epea',
        etaDate: 'Iraupena data',
        engineer: 'Ingeniaria',
        priority: 'Prioritatea',
        requestForService: 'Zerbitzu eskaera',
        service: 'Zerbitzu',
        spendLimit: 'Iraupena',
        status: 'Egoera',
        workPermit: 'Lan baimena',
      },
    },
  },
}
